import { gql } from "@apollo/client";

const LOGIN_SHADOW_ACCOUNT = gql`
  mutation Mutation {
    shadowLogin
  }
`;

export {
  LOGIN_SHADOW_ACCOUNT
};
